import { useModel } from "@stem-sims/nexus"
import { PulseLoader } from "react-spinners"
import { useCallback } from "react"
import { createBlock, deleteBlock, getBlocks } from "shared/routes/reviewRoutes"
import { toast } from "react-toastify"
import EditingListPane from "../EditingListPane"

export default function EditingBlocks() {
    const { loading, response: blocks, refreshModel: refresh } = useModel({
        model: getBlocks,
    })

    const createBlockCallback = useCallback(async () => {
        try {
            const message = await createBlock()
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh])

    const deleteBlockCallback = useCallback(async (values: { id: string }) => {
        try {
            const message = await deleteBlock(values.id)
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh])

    if (loading || !blocks) {
        return <>
            <PulseLoader />
        </>
    }

    return <>
        <div className="w-50 m-auto">
            <EditingListPane
                parent={null}
                items={blocks.map((block) => ({ id: block.id, name: block.block }))}
                itemType="block"
                createItem={createBlockCallback}
                updateItem={null}
                deleteItem={deleteBlockCallback}
            />
        </div>
    </>
}
